module.exports = __webpack_public_path__ + "img/895.ab0534a7.gif";